import { get, isEmpty, startCase, isArray } from "lodash";

let MetaSettings = {
  /* This mutates uiMetaSettings
   * This process parse the json settings and bind each of then with the value of the setting (bindingFunc)
   * bindingFunc knows about the device registry data.
   * */
  forEachSetting(uiMetaSettings, bindingFunc) {
    this.prefix = uiMetaSettings.path;
    Object.keys(uiMetaSettings.fields).forEach((settingKey) => {
      this.settingKey = settingKey;
      this.field = uiMetaSettings.fields[settingKey];
      this.hasOwnPath = typeof this.field.path === "string";
      this.hasLabel = typeof this.field.label === "string";
      this.setPathForIndividualField();
      this.createLabel();
      this.parseSelectFieldMetaOptions();
      bindingFunc(this.field);
    });
    return null;
  },
  createLabel() {
    if (!this.hasLabel) {
      this.field.label = startCase(this.settingKey);
    }
  },
  parseSelectFieldMetaOptions() {
    if (
      this.field.ui === "select" &&
      this.field.input.options &&
      typeof get(this.field, "input.options[0]") !== "object"
    ) {
      // when value and label are the same
      this.field.input.options = this.field.input.options.map((option) => ({
        value: option,
        label: option,
      }));
    }
  },
  setPathForIndividualField() {
    if (this.hasOwnPath) {
      // let the own field absolute path
    } else {
      this.field.path = this.prefix + "." + this.settingKey;
    }
  },
};

function bindJsonSettings(device, bootUp) {
  const missingSettings = [];
  bootUp((setting) => {
    if (setting === null || typeof setting === "undefined") {
      // console.error(new Error("Setting configuration does not exist!").stack);
    }
    setting.missing = false;
    const path = setting.path;
    const value = get(device, path, "not_found");

    if (value === "not_found") {
      setting.missing = true;
      missingSettings.push({ label: setting.label, setting: setting.path });
      return;
    }
    setting.value = value;
  });

  // if (isEmpty(missingSettings) === false)
  // console.info(
  //   `Ring Pro: Missing Setting >>> `,
  //   JSON.stringify(missingSettings, null, " ")
  // );
}

function bindDeviceSettings(device, settingsJson) {
  settingsJson.forEach((item) => {
    if (item.hasOwnProperty("fields")) {
      let uiMetaSettings = item;

      // console.assert(
      //   typeof uiMetaSettings.fields === "object",
      //   "`fields` property must be an object"
      // );
      // console.assert(
      //   uiMetaSettings.hasOwnProperty("path"),
      //   "Device setting path not specified for this item in the meta setting Json file."
      // );
      let metaSettings = Object.create(MetaSettings);
      bindJsonSettings(device, (bindingFunc) =>
        metaSettings.forEachSetting(uiMetaSettings, bindingFunc)
      );
    } else if (item.hasOwnProperty("header")) {
      item.ui = "header";
    } else if (item.hasOwnProperty("component")) {
      item.ui = item.component;
    }
  });

  return settingsJson;
}

export function initializeSettings(device) {
  return new Promise((resolve, reject) => {
    let file;
    try {
      file = require(`./meta/${device.type}.json`);
    } catch (e) {
      const error = new Error(
        `Not settings configuration file for device type(${device.type})`
      ).stack;
      // console.error(error);
      reject(error);
    }
    resolve(file);
  }).then((response) =>
    bindDeviceSettings(device, get(response, "data", response))
  );
}
